export default __webpack_public_path__ + "static/Corporate_Responsibility_Header-768e20caaa915033697ec8962f06763e.jpg";